import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  FaBus,
  FaArrowRight,
  FaMapMarkerAlt,
  FaClock,
  FaIdCard,
  FaSnowflake,
  FaCheckCircle,
} from "react-icons/fa";
import heroBanner from "../Assets/banners/hero.png";
import heroVideo from "../Assets/videos/Staffline_Video.mp4";
import "./HeroSection.css";

const HeroSection = () => {
  /* ===== PHASES: "banner" | "video" ===== */
  const [phase, setPhase] = useState("banner");
  const [showCard, setShowCard] = useState(false);

  const videoRef = useRef(null);

  /* ===== PHASE 1: BANNER TIMING ===== */
  useEffect(() => {
    if (phase !== "banner") return;

    // Reset card visibility at start of banner phase
    setShowCard(false);

    // After 2s → show card
    const cardTimer = setTimeout(() => setShowCard(true), 2000);

    // After 5s → switch to video phase
    const switchTimer = setTimeout(() => {
      setShowCard(false);
      setPhase("video");
    }, 5000);

    return () => {
      clearTimeout(cardTimer);
      clearTimeout(switchTimer);
    };
  }, [phase]);

  /* ===== PHASE 2: VIDEO TIMING ===== */
  useEffect(() => {
    if (phase !== "video") return;

    setShowCard(false);

    // After 2s → show card
    const cardTimer = setTimeout(() => setShowCard(true), 2000);

    return () => clearTimeout(cardTimer);
  }, [phase]);

  /* ===== HANDLE VIDEO END ===== */
  const handleVideoEnd = () => {
    setShowCard(false);
    setPhase("banner");
  };

  return (
    <section className="staffline-hero">

      {/* ===== BANNER (PHASE 1) ===== */}
      {phase === "banner" && (
        <div
          className="staffline-hero-banner"
          style={{ backgroundImage: `url(${heroBanner})` }}
        >
          <div className="staffline-hero-banner-overlay"></div>
        </div>
      )}

      {/* ===== VIDEO (PHASE 2) ===== */}
      {phase === "video" && (
        <div className="staffline-hero-video-wrap">
          <video
            ref={videoRef}
            className="staffline-hero-video"
            src={heroVideo}
            autoPlay
            muted
            playsInline
            onEnded={handleVideoEnd}
          />
          <div className="staffline-hero-video-overlay"></div>
        </div>
      )}

      {/* ===== TEXT CONTENT (Always Visible) ===== */}
      <div className="container staffline-hero-content">
        <span className="staffline-hero-tag">
          <FaBus /> Reliable Staff Mobility
        </span>

        <h1 className="staffline-hero-title">
          StaffLine <span>Transport Ltd</span>
        </h1>

        <p className="staffline-hero-subtitle">
          A reliable staff mobility solution — subscription-based, safe,
          comfortable, and always on time.
        </p>

        <div className="staffline-hero-actions">
          <Link to="/subscription" className="staffline-hero-btn-primary">
            Subscribe Now <FaArrowRight />
          </Link>
          <Link to="/routes" className="staffline-hero-btn-secondary">
            View Routes
          </Link>
        </div>
      </div>

      {/* ===== FLOATING CARD (Appears at bottom-right in both phases) ===== */}
      {showCard && (
        <div className="staffline-hero-card">
          <div className="staffline-hero-card-header">
            <div className="staffline-hero-card-icon">
              <FaBus />
            </div>
            <div>
              <h3>Why StaffLine?</h3>
              <span>Trusted by workers daily</span>
            </div>
          </div>

          <ul className="staffline-hero-card-list">
            <li>
              <FaMapMarkerAlt />
              <span>24+ Routes Across Accra & Tema</span>
            </li>
            <li>
              <FaClock />
              <span>Fixed Schedules, On-Time Every Day</span>
            </li>
            <li>
              <FaIdCard />
              <span>Assigned Seats + ID Card System</span>
            </li>
            <li>
              <FaSnowflake />
              <span>AC Buses with CCTV Monitoring</span>
            </li>
            <li>
              <FaCheckCircle />
              <span>800 GHS Flat Monthly Fee</span>
            </li>
          </ul>
        </div>
      )}

    </section>
  );
};

export default HeroSection;